export function useInputUtils() {
    const getInputValue = (event: Event)  => {
       return (event.target as HTMLInputElement)?.value ?? '';
    }

    return {
        getInputValue,
    }
}